import { useCallback, useEffect, useState } from "react";
import { PublicPageStyle } from "../../constants/styles";
import {
  EplusDataType,
  RouterType,
  ShowcaseDataType,
  SiteCategoryType,
} from "../../constants/types";
import ShowcaseTemplate from "../templates/ShowcaseTemplate";
import { getSiteList } from "../../api/common";
import { getEplusList, getShowcaseList } from "../../api/showcase";

const ShowcasePage = (props: RouterType) => {
  const [categories, setCategories] = useState<SiteCategoryType[]>([]);
  const [data, setData] = useState<{
    showcase: ShowcaseDataType[];
    eplus: EplusDataType[];
  }>({ showcase: [], eplus: [] });
  const [render, setRender] = useState(false);
  const [showcasePage, setShowcasePage] = useState<number>(0);
  const [eplusPage, setEplusPage] = useState<number>(0);

  const [options, setOptions] = useState({
    showcase: {
      siteNo: "all",
      zoneNo: "all",
    },
    eplus: {
      siteNo: "all",
      zoneNo: "all",
    },
  });

  const getCommonData = useCallback(async () => {
    const category = await getSiteList();
    setCategories(category);
  }, []);
  const getData = useCallback(async () => {
    const showcase = await getShowcaseList(
      1,
      10000,
      options.showcase.siteNo,
      options.showcase.zoneNo
    );
    const eplus = await getEplusList(
      1,
      10000,
      options.eplus.siteNo,
      options.eplus.zoneNo
    );
    setData({
      showcase: showcase,
      eplus: eplus,
    });
  }, [options]);

  useEffect(() => {
    getCommonData();
  }, []);

  useEffect(() => {
    getData();
  }, [props.render, render, options]);

  useEffect(() => {
    setShowcasePage(0);
  }, [options.showcase]);
  useEffect(() => {
    setEplusPage(0);
  }, [options.eplus]);

  return (
    <PublicPageStyle>
      <ShowcaseTemplate
        option={{ options, setOptions }}
        categories={categories}
        data={data}
        render={{ render, setRender }}
        showcasePage={{ state: showcasePage, setState: setShowcasePage }}
        eplusPage={{ state: eplusPage, setState: setEplusPage }}
      />
    </PublicPageStyle>
  );
};

export default ShowcasePage;
